module.exports = __webpack_public_path__ + "img/linkedinLogo.dff2e8ec.svg";